import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import $$i18n from 'models/i18n';
import { initReactI18next } from 'react-i18next';

import { API_URL } from 'utils/api-helper';

const isLocalhost = ['localhost', '192.168'].some((host) => window.location.host.includes(host));

i18n.use(Backend)
    .use(initReactI18next)
    .init(
        {
            lng: 'en-US',
            supportedLngs: ['en-US'],
            debug: false,
            ns: [
                'common',
                'errors',
                'assessment',
                'ep',
                'learningCenter',
                'spec_instructions',
                'dashboard_assessment',
                'approx-age',
                'ahcd',
                'gdpoa',
                'hcpoa',
                'hipaa',
                'lw',
            ],
            defaultNS: 'common',
            fallbackNS: 'errors',
            interpolation: {
                escapeValue: false,
            },
            backend: {
                // loadPath: API_URL + '/locales/{{lng}}/{{ns}}',
                //loadPath: 'http://localhost:8090' + '/locales/{{lng}}/{{ns}}',
                loadPath: (isLocalhost ? 'http://localhost:8090' : API_URL) + '/locales/{{lng}}/{{ns}}',
            },
        },
        $$i18n.localesLoaded,
    );

export default i18n;

const t = i18n.t.bind(i18n);
export { t };
